import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { whyDiffer } from '../../data/teaser';
import { QuizOverlay } from '../QuizOverlay';
const EASE = [0.23, 1, 0.32, 1] as const;
export function WhyDifferScreen() {
  const [quizOpen, setQuizOpen] = useState(false);
  return <div className="relative flex flex-1 flex-col" data-id="element-819" data-mp="eazarxf4zco5">
      <div className="flex items-start justify-between gap-3" data-id="element-820" data-mp="ecaclrp0uacm">
        <motion.h2 initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        ease: EASE
      }} className="font-display text-[26px] font-semibold leading-[1.1] text-navy" data-id="element-821" data-mp="9bwg96ws8ouf">
          {whyDiffer.headline}
        </motion.h2>

        <motion.button type="button" onClick={() => setQuizOpen(true)} animate={{
        opacity: [1, 0.45, 1]
      }} transition={{
        duration: 1.6,
        repeat: Infinity,
        ease: 'linear'
      }} className="mt-1 shrink-0 rounded-full bg-blue px-3.5 py-1.5 text-[11px] font-semibold text-paper transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2" data-id="element-822" data-mp="3qsxgmysvuym1">
          Quiz?
        </motion.button>
      </div>

      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.28,
      delay: 0.1,
      ease: EASE
    }} className="mt-4 overflow-hidden rounded-xl border border-line" data-id="element-823" data-mp="233raiixxxkjz">
        <div className="flex h-[150px] items-center justify-center bg-[#0A0F14]" data-id="element-824" data-mp="2zrxcey3h9yuk">
          <img src={whyDiffer.image} alt={whyDiffer.imageAlt} draggable={false} className="max-h-full w-full select-none object-contain" data-id="element-825" data-mp="2zpt9aidel3vc" />
        </div>
        <figcaption className="border-t border-line bg-mist px-3 py-1.5 text-[9px] uppercase tracking-micro text-mut" data-id="element-826" data-mp="1ad92d3id0szp">
          {whyDiffer.caption}
        </figcaption>
      </motion.figure>

      <p className="mt-4 text-[13px] leading-relaxed text-mut" data-id="element-827" data-mp="1f9zifqu5zol4">{whyDiffer.copy}</p>
      <p className="mt-2.5 text-[13px] leading-relaxed text-navy" data-id="element-828" data-mp="3h3m3dnjdck3z">{whyDiffer.then}</p>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.28,
      ease: EASE
    }} className="mt-auto pt-5 font-display text-[21px] font-semibold leading-snug text-blue" data-id="element-829" data-mp="3c36sr3qh1qpp">
        {whyDiffer.takeaway}
      </motion.p>

      <AnimatePresence data-id="element-830" data-mp="2y8xcg4sgca7t">
        {quizOpen && <QuizOverlay onClose={() => setQuizOpen(false)} data-id="element-831" data-mp="2tc709sjrpyro" />}
      </AnimatePresence>
    </div>;
}